import { SponsorApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useSponsorsAPI(): SponsorApi {
  return new SponsorApi(apiConfig);
}
